if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        setTimeout(() => {
       
          const isMobile = (window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent));
          
          this.cart = isMobile ? document.querySelector('cart-drawer') : document.querySelector('cart-notification');
          this.submitButton = this.querySelector('[type="submit"]');

          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

          this.hideErrors = this.dataset.hideErrors === 'true';
        }, 1000);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if(this.closest('product-info').querySelector('select#frame-color')){
          if(this.form.querySelector('#frame-color-input').value === 'null' || this.form.querySelector('#frame-color-input').value === '' && this.form.closest('product-info').querySelector('variant-radios input:checked').value === 'Framed Canvas'){
            this.handleErrorMessage("Choose a frame color");
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (formData.has('properties[Frame Color]')) {
          // Key exists and checking values
          let value = formData.get('properties[Frame Color]');
          if (value === '' || value === 'null' ) {
             formData.delete('properties[Frame Color]');
          } 
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            setTimeout(() => {
              document.updateCartGift();
            }, 1000);
            window.upsellLogic();
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        const errorMessageWrappers = document.querySelectorAll('.product-form__error-message-wrapper');
        const errorMessages = document.querySelectorAll('.product-form__error-message');

        errorMessageWrappers.forEach((wrapper, index) => {
            wrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage && errorMessages[index]) {
                errorMessages[index].textContent = errorMessage;
            }
        });

        if (errorMessage) {
            if (errorMessage.includes(errorMessage)) {
              const frameColorSection = document.querySelector('.product-form__input .product_type__colors');
              if (frameColorSection) {
                  window.scrollTo({
                      top: frameColorSection.offsetTop - 350, 
                      behavior: 'smooth'
                  });
              }
          }
        }
      }
    }
  );
}
